
<div class="col">
  <div class="col-8 float-right web-tr rmbrsmnt-spprtserv hidden-xs">
    <a (click)="navigateToResourcePage()" title="Back to dashboard">
      <img src="/icons/{{baseSiteId}}/chevron-left_green.svg" alt="" class="chevron-left">
    Back to coding education reimbursement support</a>
  </div>
</div>
<div class="row ml-0 mr-0" id="leftCont-rightNav">
  <section id="left-section" class="col-lg-8 col-md-8">
    <div class="row">
      <div class="col">
        <div class="content border-bottom-1" [innerHTML]="cmsResponseBodyDesc"></div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="content border-bottom-1" [innerHTML]="cmsResponseCallSupportContent"></div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="content border-bottom-1">
          <div [innerHTML]="cmsResponseEmailFaxTitle"></div>
          <ul class="li-imgtext">
            <li>
              @if (reimbursePdfDetailsObj?.document?.mime == 'application/pdf') {
                <img
                  src="/icons/{{baseSiteId}}/pdf.svg" alt="pdf">
                }
                <a (click)="downloadPdf(reimbursePdfDetailsObj?.document?.downloadUrl)" name="pdf">
                  {{reimbursePdfDetailsObj?.document?.name}}
                </a>
              </li>
              <li>
                <img gIf="fluInquiryPdfDetailsObj?.document?.mime == 'application/pdf'"
                  src="/icons/{{baseSiteId}}/pdf.svg" alt="pdf">
                  <a (click)="downloadPdf(fluInquiryPdfDetailsObj?.document?.downloadUrl)" name="pdf">
                    {{fluInquiryPdfDetailsObj?.document?.name}}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div id="reimbrsmnt-cntctOnline" class="coding-reimbursement resupport-service">
          <div class="row ">
            <div class="col">
              <h3 class="blue-sec mt-4">Contact us online</h3>
              @if (!detailsSuccessfullySubmitted) {
                <p class="grey-sec">Fill out the following online form,
                  including some specifics about your
                situation and how we can help you.</p>
              }
              @if (detailsSuccessfullySubmitted) {
                <p class="grey-sec">
                  <img src="/icons/confirmation-positive-green.png">
                  Your message has been sent and the support team will contact you.
                </p>
              }
            </div>
          </div>
          @if (!detailsSuccessfullySubmitted) {
            <form id="sanofiContactOnlineForm" [formGroup]="contactOnlineForm"
              (ngSubmit)="onFormSubmit()">
            <div class="row">
              <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6 p-rytlft Fields-container">
                <label class="Fields-label">Location name</label>
                <input id="locationName" formControlName="locationName" type="text" class="Fields-input">
                @if ((contactOnlineForm.controls.locationName?.touched || submitted) && contactOnlineForm.controls.locationName?.errors?.required) {
                  <span class="defaultMessage" role="alert"
                    aria-live="assertive">This
                  field is required</span>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6  p-rytlft Fields-container">
                <label class="Fields-label">Contact name</label>
                <input id="contactName" formControlName="contactName" type="text" class="Fields-input">
                @if ((contactOnlineForm.controls.contactName?.touched && contactOnlineForm.controls.contactName?.value && !contactOnlineForm.controls.contactName?.valid)) {
                  <span class="defaultMessage" role="alert" aria-live="assertive"
                    >Please
                  Enter Valid Contact name.</span>
                }
                @if ((contactOnlineForm.controls.contactName?.touched || submitted) && contactOnlineForm.controls.contactName?.errors?.required) {
                  <span class="defaultMessage" role="alert" aria-live="assertive"
                    >This
                  field is required</span>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6 p-rytlft Fields-container">
                <label class="Fields-label">Position or title <span class="optional">(Optional)</span></label>
                <input id="title" formControlName="title" type="text" class="Fields-input field-optional">
                @if ((contactOnlineForm.controls.title?.touched && contactOnlineForm.controls.title?.value && !contactOnlineForm.controls.title?.valid)) {
                  <span class="defaultMessage"
                    >This
                  field accepts alphanumeric characters and spaces as well.</span>
                }
                @if ((contactOnlineForm.controls.title?.touched || submitted) && contactOnlineForm.controls.title?.errors?.required) {
                  <span class="defaultMessage"
                  ></span>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6  p-rytlft Fields-container">
                <label class="Fields-label">Street address</label>
                <input id="streetAddress" formControlName="streetAddress" type="text" class="Fields-input">
                @if ((contactOnlineForm.controls.streetAddress?.touched || submitted) && contactOnlineForm.controls.streetAddress?.errors?.required) {
                  <span class="defaultMessage" role="alert" aria-live="assertive"
                    >This
                  field is required</span>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6  p-rytlft Fields-container">
                <label class="Fields-label">City, state, zipcode</label>
                <input id="cityStateZipcode" formControlName="cityStateZipcode" type="text"
                  class="Fields-input">
                @if ((contactOnlineForm.controls.cityStateZipcode?.touched || submitted) && contactOnlineForm.controls.cityStateZipcode?.errors?.required) {
                  <span class="defaultMessage" role="alert" aria-live="assertive"
                    >This
                  field is required</span>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6 p-rytlft Fields-container">
                <label class="Fields-label">Telephone</label>
                <input id="telephone" formControlName="telephone" type="text"
                  class="Fields-input phone-no-valid" onkeypress="return /[0-9]/.test(event.key)"
                  (keyup)="formatPhoneNumber($event)" (paste)="formatPhoneNumber($event)" maxlength="12">
                @if (contactOnlineForm.controls.telephone?.value && !contactOnlineForm.controls.telephone?.valid) {
                  <span class="defaultMessage" role="alert" aria-live="assertive"
                    >This
                  field accepts numeric 10 digit phone number</span>
                }
                @if ((contactOnlineForm.controls.telephone?.touched || submitted) && contactOnlineForm.controls.telephone?.errors?.required) {
                  <span class="defaultMessage" role="alert" aria-live="assertive"
                    >This
                  field is required</span>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6  p-rytlft Fields-container">
                <label class="Fields-label">Fax <span class="optional">(Optional)</span></label>
                <input id="fax" formControlName="fax" onkeypress="return /[0-9]/.test(event.key)"
                  (paste)="formatFaxNumber($event)" (change)="formatFaxNumber($event)" type="text"
                  class="Fields-input field-optional phone-no-valid" maxlength="12">
                @if (contactOnlineForm.controls.fax?.value && !contactOnlineForm.controls.fax?.valid) {
                  <span class="defaultMessage" role="alert" aria-live="assertive"
                    >This
                  field accepts numeric 10 digit fax number</span>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6 p-rytlft Fields-container">
                <label class="Fields-label">Email address</label>
                <input id="emailAddress" formControlName="emailAddress" data-valid="valid_mail" type="text"
                  class="Fields-input">
                @if ((contactOnlineForm.controls.emailAddress?.touched && contactOnlineForm.controls.emailAddress?.value && !contactOnlineForm.controls.emailAddress?.valid)) {
                  <span class="defaultMessage"
                    >Invalid
                  email address</span>
                }
                @if ((contactOnlineForm.controls.emailAddress?.touched || submitted) && contactOnlineForm.controls.emailAddress?.errors?.required) {
                  <span class="defaultMessage"
                    >This
                  field is required</span>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-10 p-rytlft Fields-container">
                <label class="Fields-label">Your question</label>
                <textarea id="comment" formControlName="question"
                  placeholder="Please give us a detailed question you would like answered."
                class="mt-0 Fields-textarea"></textarea>
                @if ((contactOnlineForm.controls.question?.touched || submitted) && contactOnlineForm.controls.question?.errors?.required) {
                  <span class="defaultMessage mb1"
                    >This
                  field is required</span>
                }
              </div>
            </div>
            <div class="row ml-1 mt-5">
              <button type="submit" id="contactonline" class="btn-primary RSService-btn "
              data-di-id="#contactonline">Submit request</button>
            </div>
            <div>
              <input type="hidden" name="CSRFToken" value="f9b7e60a-e21f-4831-9c18-a735da5f7e05">
            </div>
          </form>
        }

      </div>
    </section>
    <section id="right-section" class="col-lg-4 col-md-4">

    </section>
  </div>
